var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"label"},[_c('div',{staticClass:"toggle"},[_c('input',{staticClass:"toggle-state",attrs:{"type":"checkbox","name":"check","value":"check"}}),_c('div',{staticClass:"indicator"},[_c('i',{staticClass:"fas fa-moon"}),_c('i',{staticClass:"fas fa-sun"})])])])
}]

export { render, staticRenderFns }